import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import { QRCodeSVG } from "qrcode.react";
import ReactDOMServer from "react-dom/server";

(pdfMake as any).vfs = pdfFonts?.pdfMake?.vfs;

function getBase64Image(img: Blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

const AutorizacaoLote = async (dados: any) => {
    const today = new Date();
    const dia = today.getDate();
    const mes = today.toLocaleString("pt-BR", { month: "long" });
    const ano = today.getFullYear();

    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob)) as string;
    const imageConvert = await fetch("/img/logo/logoArmed.png").then((res) => res.blob());
    const imageArmed = (await getBase64Image(imageConvert)) as string;

    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/autorizacao/${dados?._id}`}
            type="svg"
        />
    );

    function gararTabela0() {
        const table = {
            headerRows: 1,
            widths: ['25%', '*', 'auto', '20%'],
            body: [
                [
                    { text: 'Produto', fillColor: '#BDD6EE', style: 'bodyTabela', color: '#000', alignment: 'center', bold: true },
                    { text: 'Fabricante', fillColor: '#BDD6EE', style: 'bodyTabela', color: '#000', alignment: 'center', bold: true },
                    { text: 'Validade', fillColor: '#BDD6EE', style: 'bodyTabela', color: '#000', alignment: 'center', bold: true },
                    { text: 'Lote', fillColor: '#BDD6EE', style: 'bodyTabela', color: '#000', alignment: 'center', bold: true },
                ],
                [
                    { text: dados?.producto?.nome, style: 'bodyTabela', color: '#111', alignment: 'center', },
                    { text: dados?.producto?.fabricante ?? '', style: 'bodyTabela', color: '#111', alignment: 'center', },
                    { text: new Date(dados?.producto?.dataValidade).toLocaleDateString('pt-BR'), style: 'bodyTabela', color: '#111', alignment: 'center', },
                    { text: dados?.producto?.lote, style: 'bodyTabela', color: '#111', alignment: 'center', },
                ],
            ],
        };
        return table;
    }

    const docDefinition: TDocumentDefinitions = {
        pageSize: "A4",
        pageMargins: [45, 40, 45, 80],

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                        ],
                        alignment: "left",
                        style: "header",
                    },
                    {
                        image: imageBase64 as string,
                        width: 80,
                        height: 80,
                        alignment: "center",
                    },
                    {
                        text: "",
                        width: "43%",
                    },

                ],
                margin: [0, 0, 0, 2],
            },
            // {
            //     image: imageBase64 as string,
            //     width: 80,
            //     height: 80,
            //     alignment: "center",
            // },
            { text: "REPÚBLICA DE ANGOLA", style: "header" },
            { text: "MINISTÉRIO DA SAÚDE", style: "header" },
            {
                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                style: "header",
            },
            {
                text: [
                    `AUTORIZAÇÃO DE LIBERAÇÃO DE LOTE N.º`,
                    {
                        text: `${dados?.numeroAutorizacao}`,
                        bold: true,
                    },
                    "/ARMED/MINSA/",
                    {
                        text: `${new Date(dados?.producto?.dataDespacho).getFullYear()}`
                    }
                ],
                style: "header",
                margin: [0, 10, 0, 10],
            },
            {
                text: [
                    `========== Para os devidos efeitos, declara - se que `,
                    { text: `${dados?.solicitacaoAnalise?.nome}, `, bold: true },
                    ` sita no`,
                    { text: ` ${dados?.solicitacaoAnalise?.bairro} - ${dados?.solicitacaoAnalise?.municipio}, ${dados?.solicitacaoAnalise?.provincia}`, bold: true },
                    ` e nos termos dos Decretos 180/10 de Agosto, 191/10 de 01 de Setembro e 136/21 de 01 de Junho, está autorizada a proceder à distribuição dos lotes abaixo referenciados. =====================================================`,
                ],
                style: "body",
                margin: [0, 10, 0, 35],
            },
            { table: gararTabela0() },
            {
                text: `========== E por ser verdade, passou - se a presente autorização que vai por mim assinada e autenticada com o carimbo a óleo em uso nesta Instituição. ==========================`,
                style: "body",
                margin: [0, 20, 0, 45],
            },

            {
                text: [
                    `AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE, EM LUANDA, AOS `,
                    { text: `${dia}`, bold: true },
                    ` DE `,
                    { text: `${mes.toUpperCase()}`, bold: true },
                    ` DE `,
                    { text: `${ano}`, bold: true },
                    `.`,
                ],
                alignment: "left",
                style: "header",
            },
            {
                text: "O DIRECTOR GERAL",
                alignment: "center",
                style: "signature",
                margin: [0, 55, 0, 10],
            },
            {
                text: "POMBAL MAYEMBE",
                alignment: "center",
                style: "signature",
            }
        ],

        footer: () => {
            return [
                {
                    text: "____________________________________________________________________________________________________",
                    style: "",
                    margin: [0, 0, 0, 0],
                    bold: true,
                    alignment: "center",
                },
                {
                    columns: [
                        {
                            stack: [
                                {
                                    text: "Rua Cmdt. Che Guevara nº 6/86º Bº Maculusso, Ingombota",
                                    style: "",
                                    margin: [0, 10, 0, 0],
                                    bold: true,
                                },
                                {
                                    text: "Tel.: +244 938 120 372",
                                    style: "",
                                    margin: [0, 0, 0, 0],
                                    bold: true,
                                },
                                {
                                    text: "Email: geral@armed.minsa.gov.ao LUANDA-ANGOLA",
                                    style: "",
                                    margin: [0, 0, 0, 0],
                                    bold: true,
                                },
                            ],
                            width: "70%",
                            fontSize: 9,
                            alignment: "left",
                        },
                        {
                            width: "30%",

                            stack: [
                                {
                                    image: imageArmed as string,
                                    width: 100,
                                    height: 40,
                                    alignment: "center" as "center",
                                },
                            ],
                        },
                    ],
                    alignment: "center",
                    fontSize: 8,
                    margin: [50, 0, 50, 0],
                },
            ];
        },

        images: {
            mySuperImage: `data:image/jpeg;base64,/${imageBase64}`,
            // in browser is supported loading images via url (https or http protocol) (minimal version: 0.1.67)
            snow: "/img/logo/logoArmed.png",
            // is supported loading images via url with custom headers (minimal version: 0.2.5)
            strawberries: {
                url: "/img/logo/logoArmed.png",
                headers: {
                    myheader: "123",
                    myotherheader: "abc",
                },
            },
        } as Record<string, any>,

        styles: {
            header: {
                fontSize: 12,
                bold: true,
                alignment: "center",
                margin: [0, 0, 0, 0],
            },
            bodyTabela: {
                fontSize: 12,
                alignment: "justify",
                margin: [0, 0, 0, 0],
                lineHeight: 1,
            },
            body: {
                fontSize: 12,
                alignment: "justify",
                margin: [0, 0, 0, 0],
                lineHeight: 1,
            },
            signature: {
                fontSize: 11,
                bold: true,
                margin: [0, 10, 0, 0],
            },
        },
        defaultStyle: {
            font: "Roboto",
        },
    };

    pdfMake.createPdf(docDefinition).open();
}

export default AutorizacaoLote
